/* eslint-disable no-prototype-builtins */
/* eslint-disable no-unused-vars */
/* eslint-disable camelcase */
import { Field, useFormikContext } from 'formik'
import React, { useEffect, useState } from 'react'
// import styles from '@/styles/global/components/Form.module.scss'
import InputMask from 'react-input-mask'
import { usePartnerData } from 'hooks/usePartnerData'

const CustomInput = (props) => <InputMask {...props}>{(inputProps) => <Field {...inputProps} />}</InputMask>

function replaceText(optionLabel, textToFilter, replacementText) {
  if (!optionLabel || typeof optionLabel !== 'string') {
    throw new Error('optionLabel must be a string')
  }

  return optionLabel.replace(new RegExp(textToFilter, 'g'), replacementText)
}

const GenerateField = ({ field, error, formData }) => {
  const { legalName } = usePartnerData()

  const [isVisible, setIsVisible] = useState(true)
  const [phoneHasValue, setPhoneHasValue] = useState(false)
  const { values, isSubmitting, isValid, dirty, setFieldValue } = useFormikContext()
  const [cbgIsChecked, setCbgIsChecked] = useState(false)

  const { phone_number } = values

  // if phone_number has a value, set phoneHasValue to true
  // if phone_number is empty, set phoneHasValue to false
  useEffect(() => {
    if (phone_number !== undefined && phone_number !== '') {
      setPhoneHasValue(true)
    } else {
      setPhoneHasValue(false)
    }
  }, [phone_number])

  // const shouldHide = formData && Boolean(formData[alias]); // check if field is already populated in formData
  // setting to false for now to show all fields b/c I haven't figured out how to populate fields correctly
  let shouldHide = false

  //  const [field, meta] = useField(props);
  const {
    id,
    label,
    alias,
    type,
    defaultValue,
    isRequired,
    validationMessage,
    helpMessage,
    properties,
    parent,
    conditions,
    containerAttributes,
    labelAttributes,
    inputAttributes,
    showLabel,
  } = field

  // if alias = hp_css, return null
  if (alias === 'hp_css') {
    return null
  }

  // if alias = nickname_bhpot, set shouldHide = true
  if (alias === 'nickname_bhpot') {
    shouldHide = true
  }

  const inputValue = values[alias] ?? ''

  const getParentFieldValue = (parentFieldId) => {
    //    convert parentFieldId to number
    const parentFieldIdNumber = Number(parentFieldId)
    const parentField = formData.find((theField) => theField.id === parentFieldIdNumber)
    const parentFieldValue = parentField.alias ? values[parentField.alias] : null
    return parentField ? parentFieldValue : null
  }
  const isMyParentValueSelected = (parentFieldValue) => {
    const childConditions = conditions.values[0]
    const parentFieldIsEmpty = parentFieldValue === undefined || parentFieldValue === ''
    if (childConditions === 'Yes') {
      return !parentFieldIsEmpty
    }
    return parentFieldValue === childConditions
  }

  const shouldFieldBeHidden = () => {
    if (parent) {
      const parentFieldValue = getParentFieldValue(parent)
      return parentFieldValue !== null && !isMyParentValueSelected(parentFieldValue)
    }
    return false
  }

  useEffect(() => {
    setIsVisible(!shouldFieldBeHidden())
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values, field])

  useEffect(() => {
    if (parent) {
      const parentFieldValue = getParentFieldValue(parent)

      // Clear the child select's value when parent value changes
      if (!isMyParentValueSelected(parentFieldValue)) {
        setFieldValue(alias, '') // Clear child select value
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values, parent])

  if (shouldFieldBeHidden()) {
    return null
  }

  if (!isVisible) {
    return null // Hide the field if it should be hidden
  }

  switch (type) {
    case 'select': {
      const selectOptions = properties.list.list.map((option) => (
        <option key={option.value} value={option.value}>
          {option.label}
        </option>
      ))

      const handleSelectChange = (event) => {
        setFieldValue(alias, event.target.value)
      }

      return (
        <div className={`${field.type} ${field.alias} ${containerAttributes}`} key={field.id}>
          <label htmlFor={alias} className={labelAttributes}>
            {label}
          </label>
          {isRequired && <span className="required">*</span>}
          <Field
            name={alias}
            as="select"
            value={inputValue === null ? '' : inputValue}
            onChange={handleSelectChange}
            className={error ? 'is-invalid' : ''}
          >
            <option value="">Select</option>
            {selectOptions}
          </Field>
          {error && error}
          {helpMessage && <small>{helpMessage}</small>}
        </div>
      )
    }
    case 'text':
      return !shouldHide ? (
        <div className={`question ${field.type} ${field.alias} ${containerAttributes}`} key={field.id}>
          <label htmlFor={alias}>
            {label} {isRequired && <span className="required">*</span>}
          </label>

          <Field
            name={alias}
            type="text"
            value={inputValue === null ? '' : inputValue}
            onChange={(event) => setFieldValue(alias, event.target.value)}
            placeholder={properties.placeholder}
            className={inputAttributes + (error ? ' is-invalid ' : '')}
          />
          {error && <span>{error}</span>}
          {helpMessage && <small>{helpMessage}</small>}
        </div>
      ) : (
        <Field key={id} name={alias} type="hidden" />
      )
    case 'email':
      return !shouldHide ? (
        <div className={`question ${field.type} ${field.alias} ${containerAttributes}`} key={field.id}>
          <label htmlFor={alias} className={labelAttributes}>
            {label} {isRequired && <span className="required">*</span>}
          </label>

          <Field
            name={alias}
            type="email"
            placeholder={properties.placeholder}
            value={inputValue === null ? '' : inputValue}
            onChange={(event) => setFieldValue(alias, event.target.value)}
            className={error ? 'is-invalid' : ''}
          />
          {error && <span>{error}</span>}
          {helpMessage && <small>{helpMessage}</small>}
        </div>
      ) : (
        <Field key={id} name={alias} type="hidden" />
      )
    case 'hidden':
      return <Field key={id} name={alias} type="hidden" value={inputValue === null ? '' : inputValue} />
    case 'button':
      return (
        <div className={`${field.type}-container ${field.alias} ${containerAttributes}`} key={field.id}>
          <button className="button btn-primary" type="submit" disabled={isSubmitting && isValid && dirty}>
            {isSubmitting ? 'Submitting...' : label}
          </button>
        </div>
      )
    case 'tel': {
      return (
        <div className={`question ${field.type} ${field.alias} ${containerAttributes}`} key={field.id}>
          <label htmlFor={alias}>
            {label} {isRequired && <span className="required">*</span>}
          </label>
          <CustomInput
            mask="(999) 999-9999"
            name={alias}
            onChange={(e) => {
              const value = e.target.value || ''
              const changedValue = value.replace(/\)/g, '').replace(/\(/g, '').replace(/-/g, '').replace(/ /g, '')
              setFieldValue(alias, value)
            }}
          />

          {/* <Field
            name={alias}
            type="tel"
            placeholder={properties.placeholder}
            value={inputValue === null ? '' : inputValue}
            onChange={(event) => setFieldValue(alias, event.target.value)}
            className={error ? 'is-invalid' : ''}
          /> */}
          {error && error}
          {helpMessage && <small>{helpMessage}</small>}
        </div>
      )
    }
    case 'date':
      return (
        <div className={`question ${field.type} ${field.alias} ${containerAttributes}`} key={field.id}>
          <label htmlFor={alias} className={labelAttributes}>
            {label} {isRequired && <span className="required">*</span>}
          </label>

          <Field
            name={alias}
            type="date"
            placeholder={properties.placeholder}
            value={inputValue === null ? '' : inputValue}
            onChange={(event) => setFieldValue(alias, event.target.value)}
            className={error ? 'is-invalid' : ''}
          />
          {error && error}
          {helpMessage && <small>{helpMessage}</small>}
        </div>
      )
    case 'freetext':
    case 'freehtml': {
      return (
        <div className={containerAttributes}>
          {showLabel && <h2 className={labelAttributes}>{label}</h2>}
          <div
            className={inputAttributes}
            // eslint-disable-next-line react/no-danger
            dangerouslySetInnerHTML={{
              __html: properties.text,
            }}
          />
        </div>
      )
    }
    case 'checkboxgrp': {
      const toggleAddressGroup = (groupChecked) => {
        setCbgIsChecked(groupChecked)
      }

      return (
        <div className={`question ${field.type} ${field.alias} ${cbgIsChecked ? 'open' : 'close'}`} key={field.id}>
          <label id="checkbox-group">
            {label} {isRequired && <span className="required">*</span>}
          </label>
          <div role="group" aria-labelledby="checkbox-group">
            {properties.optionlist.list.map((option) => (
              <div className={`${field.type}-question`} key={option.value}>
                <Field
                  name={alias}
                  id={option.value}
                  type="checkbox"
                  value={option.value}
                  checked={inputValue.includes(option.value)}
                  onChange={(event) => {
                    const { value } = event.target
                    const isChecked = event.target.checked

                    setFieldValue(alias, isChecked ? [...inputValue, value] : inputValue.filter((v) => v !== value))

                    toggleAddressGroup(isChecked)
                  }}
                  className={error ? 'is-invalid' : ''}
                />
                <label htmlFor={option.value}>
                  {replaceText(option.label, '{global-token=partner-name}', legalName)}
                </label>
              </div>
            ))}
            {error && error}
            {helpMessage && <small>{helpMessage}</small>}
          </div>
        </div>
      )
    }
    case 'number': {
      return (
        <div className={`question  ${field.alias} ${field.type} ${containerAttributes}`} key={field.id}>
          <label htmlFor={alias} className={labelAttributes}>
            {label} {isRequired && <span className="required">*</span>}
          </label>

          <Field
            name={alias}
            type="number"
            placeholder={properties.placeholder}
            value={inputValue === null ? '' : inputValue}
            onChange={(event) => setFieldValue(alias, event.target.value)}
            className={error ? 'is-invalid' : ''}
          />
          {error && error}
          {helpMessage && <small>{helpMessage}</small>}
        </div>
      )
    }
    default:
      return null
  }
}

export default GenerateField
